import { memo } from "react";
import { Outlet } from "infrastructure/router";
import ConsumerProvider from "./ConsumerProvider";

const Consumers = () => (
    <ConsumerProvider>
        <Outlet />
    </ConsumerProvider>
);

export default memo(Consumers);
